import { ChevronDown, ChevronRight } from "lucide-react";

interface ToggleProps extends React.ComponentProps<"button"> {
  open: boolean;
  buttonText: React.ReactNode;
}

export function Toggle({ open, buttonText, ...props }: ToggleProps) {
  return (
    <button
      className="flex gap-x-0.5 items-center text-blue-500 underline cursor-pointer
                 decoration-blue-500 hover:text-neutral-950 dark:hover:text-neutral-200"
      {...props}
    >
      {open ? (
        <ChevronDown size={16} strokeWidth={3} className="stroke-blue-500" />
      ) : (
        <ChevronRight size={16} strokeWidth={3} className="stroke-blue-500" />
      )}
      <span>{buttonText}</span>
    </button>
  );
}
